
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class HasEnglish extends Component {

    handleHasEnglishStatus = (value) => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { value, disabled } = this.props;
        return (
            <div className="car-status">
                <Checkbox
                    disabled={disabled}
                    onChange={() => this.handleHasEnglishStatus(true)}
                    checked={value === true}
                >
                    Có
                </Checkbox>
                <Checkbox 
                    disabled={disabled}
                    onChange={() => this.handleHasEnglishStatus(false)}
                    checked={value === false}
                >
                    Không</Checkbox>
            </div>
        )
    }
}